/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getAnalyticsWebClientPromise } from '@jira/platform__observability-product-analytics-web-client-async';
import { showFlag } from '@atlassian/jira-flags/src/services';

import { defineMessage } from '@atlassian/jira-intl';

const title = defineMessage({
	id: 'relay-fetch.services.error-flags.title',
	defaultMessage: "Something's gone wrong",
	description: 'Flag title. Informs a user of an unauthenticated error.',
});

const description = defineMessage({
	id: 'relay-fetch.services.error-flags.description',
	defaultMessage: "Looks like you've been signed out. Try logging in again. ",
	description: 'Flag description. Informs a user of an unauthenticated error.',
});

const login = defineMessage({
	id: 'relay-fetch.services.error-flags.login',
	defaultMessage: 'Log in',
	description: 'Flag action button description. Indication login page action to clear the error.',
});

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const reloadPage = () => window.location.reload();

const sendAnalyticEvent = (operationName: string): void => {
	getAnalyticsWebClientPromise().then((client) => {
		const analyticsClient = client.getInstance();
		if (!analyticsClient) {
			return;
		}

		analyticsClient.sendTrackEvent({
			action: 'showed',
			actionSubject: 'unauthorizedFlag',
			attributes: {
				operation: operationName,
			},
			source: 'jiraRelayFetch',
		});
	});
};

const sendLoginClickEvent = (operationName: string): void => {
	getAnalyticsWebClientPromise().then((client) => {
		const analyticsClient = client.getInstance();
		if (!analyticsClient) {
			return;
		}

		analyticsClient.sendTrackEvent({
			action: 'clicked',
			actionSubject: 'loginButton',
			attributes: {
				operation: operationName,
				source: globalThis.window?.location?.pathname ?? '',
				referrer: globalThis.document?.referrer ?? '',
				timestamp: new Date().toISOString(),
				userAgent: globalThis.navigator?.userAgent ?? '',
			},
			source: 'jiraRelayFetch',
		});
	});
};

export const showUnauthenticatedFlag = (operationName: string): void => {
	showFlag({
		type: 'error',
		title,
		description,
		// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
		messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
		messageType: 'transactional',
		actions: [
			{
				content: login,
				onClick: () => {
					sendLoginClickEvent(operationName);
					reloadPage();
				},
			},
		],
	});
	sendAnalyticEvent(operationName);
};
